"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BillingCoreTransactionTypeEnum = void 0;
/**
 * Классификатор проводок
 */
var BillingCoreTransactionTypeEnum;
(function (BillingCoreTransactionTypeEnum) {
  /** Покупка чего либо (списание с платёжного счёта) */
  BillingCoreTransactionTypeEnum["PURCHASE"] = "PURCHASE";
  /** Удержание комиссии мерчанту */
  BillingCoreTransactionTypeEnum["MERCHANT_FEE_RETENTION"] = "MERCHANT_FEE_RETENTION";
  /** Удержание на налоги которые должен заплатить овнер */
  BillingCoreTransactionTypeEnum["TAX_RETENTION"] = "TAX_RETENTION";
  /** Удержание в пользу обязательств перед поставщиками */
  BillingCoreTransactionTypeEnum["CONTRACTORS_RETENTION"] = "CONTRACTORS_RETENTION";
  /** Получение дохода овнером в виде комиссии */
  BillingCoreTransactionTypeEnum["OWNER_FEE_RETENTION"] = "OWNER_FEE_RETENTION";
  /** Получение дохода овнером от продажи */
  BillingCoreTransactionTypeEnum["OWNER_INCOME"] = "OWNER_INCOME";
  /** Перевод в пользу контагентов */
  BillingCoreTransactionTypeEnum["PAYMENT_TO_CONTRACTORS"] = "PAYMENT_TO_CONTRACTORS";
  /** Получение денег поставщиком в виде аванса по безопасной сделке */
  BillingCoreTransactionTypeEnum["SELLER_PREPAYMENT_RECEIVED"] = "SELLER_PREPAYMENT_RECEIVED";
  /** Получение денег комиссионером в виде аванса по безопасной сделке */
  BillingCoreTransactionTypeEnum["BROKER_PREPAYMENT_RECEIVED"] = "BROKER_PREPAYMENT_RECEIVED";
  /** Пополнение доходов поставщика от продажи товара без безопасной сделки */
  BillingCoreTransactionTypeEnum["SELLER_PAYMENT_RECEIVED"] = "SELLER_PAYMENT_RECEIVED";
  /** Пополнение доходов комиссионера от продажи товара без безопасной сделки */
  BillingCoreTransactionTypeEnum["BROKER_PAYMENT_RECEIVED"] = "BROKER_PAYMENT_RECEIVED";
  /** Отправка средств поставщика из авансов в доходы после завершения оказания услуги */
  BillingCoreTransactionTypeEnum["SELLER_PREPAYMENT_CONFIRM"] = "SELLER_PREPAYMENT_CONFIRM";
  /** Отправка средств комиссионера из авансов в доходы после завершения оказания услуги */
  BillingCoreTransactionTypeEnum["BROKER_PREPAYMENT_CONFIRM"] = "BROKER_PREPAYMENT_CONFIRM";
  /** Поступление средств из авансов поставщика в доходы после завершения оказания услуги */
  BillingCoreTransactionTypeEnum["SELLER_PREPAYMENT_CONFIRMED"] = "SELLER_PREPAYMENT_CONFIRMED";
  /** Поступление средств комиссионера из авансов в доходы после завершения оказания услуги */
  BillingCoreTransactionTypeEnum["BROKER_PREPAYMENT_CONFIRMED"] = "BROKER_PREPAYMENT_CONFIRMED";
  /** Возврат плательщику на платёжный счёт за отменённую покупку */
  BillingCoreTransactionTypeEnum["REFUND_PURCHASE"] = "REFUND_PURCHASE";
  /** Списание с поставщика за отменную покупку */
  BillingCoreTransactionTypeEnum["SELLER_REFUND"] = "SELLER_REFUND";
  /** Списание с комиссионера за отменную покупку */
  BillingCoreTransactionTypeEnum["BROKER_REFUND"] = "BROKER_REFUND";
  /** Списание посреднической комиссии овнера за отменную покупку */
  BillingCoreTransactionTypeEnum["OWNER_FEE_REFUND"] = "OWNER_FEE_REFUND";
  /** Вывод заработанных средств в банк */
  BillingCoreTransactionTypeEnum["PAYOUT"] = "PAYOUT";
  /** Возврат отправленного в банк платежа */
  BillingCoreTransactionTypeEnum["REFUND_PAYOUT"] = "REFUND_PAYOUT";
})(BillingCoreTransactionTypeEnum = exports.BillingCoreTransactionTypeEnum || (exports.BillingCoreTransactionTypeEnum = {}));
